import React, { useState } from "react";
import ReportPageShell from "../components/ReportPageShell";
import MetricGrid from "../components/MetricGrid";
import MethodologyPanel from "../components/MethodologyPanel";
import { defaultFilters } from "../shared/filters";
import { useFinancialByDay } from "../shared/useFinancialByDay";
import { formatDay } from "../shared/format";

const TOOLTIP =
  "Per-DAY financial breakdown from the new engine, mirroring the old Financial Report's " +
  "daily rows. The day axis uses the SalesByDay grain on the engine's 5 AM-local business-day " +
  "boundary (shown above). SalesByDay natively carries only Orders + Gross, so the remaining " +
  "columns (Net, Tax, Tips, Service Fee, Discounts, Refunds, Transactions) are composed per day " +
  "from EventSummary for the selected event. Pick a single event to line it up against the old export.";

// Parallel to the OLD Financial Report's daily view. One row per business day, full core
// financial columns, pinned Total. Filter to a single event for the full breakdown.
export default function FinancialByDayReport() {
  const [filters, setFilters] = useState(defaultFilters);
  const state = useFinancialByDay(filters);

  return (
    <ReportPageShell
      title="Financial Summary by Day"
      tooltipText={TOOLTIP}
      filters={filters}
      onFiltersChange={setFilters}
      state={state}
    >
      {(data) => (
        <>
          {state.note && (
            <div className="mb-3 rounded-md border border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-800">
              {state.note}
            </div>
          )}
          <MethodologyPanel metrics={data.metrics} window={data.window} />
          <MetricGrid
            data={data}
            keyColumnHeader="Date"
            formatLabel={formatDay}
            exportName="FinancialSummaryByDay"
          />
        </>
      )}
    </ReportPageShell>
  );
}
